<template>
  <div class="card-base card-shadow--small records-list-tree m15">
    <h1 class="title" page_id="records_apply_subaccount">
      <span>{{$t('common.three_list.latest_records')}}</span>
    </h1>
    <div v-if="params.length" :style="{ height: height + 'px' }">
      <el-card class="box-card" v-for="(parent, key) in params" :class="classCardColor(params[key].status)" :key="key">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
            <el-tag class="status-width" :class="classColor(parent.status)">{{getKey(parent.status)}}</el-tag>
          <!-- <b>&nbsp;&nbsp;&nbsp;&nbsp;{{$t('common.three_list.accountNo')}}{{parent.accountNumber}}</b> -->
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="hidden-md-and-down text-right">
            <small class="data-time">{{parent.updatedTime | GetDate}}<br>{{parent.updatedTime | GetTime}}</small>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="hidden-md-and-up">
            <small>{{parent.updatedTime | GetDate}} {{parent.updatedTime | GetTime}}</small>
          </el-col>
        </el-row>

        <el-row :gutter="10" v-for="(child, key02) in parent.childList" :key="key02">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="param-name content-left" v-if="child">{{getKey(key02)}}</el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="param-value text-right content-right" v-if="child"><small class="data-con">{{child}}</small></el-col>
        </el-row>

      </el-card>
    </div>
    <!-- <div v-if="!params.length" v-loading="loading" class="loading" :style="{ height: height + 'px' }"></div> -->
    <div v-if="!params.length" :style="{ height: height + 'px' }">
      <el-card class="box-card ai-jc" :style="{ height: height-20 + 'px' }">
        <img :src="src" alt="" style="height:40px;width:40px">
        <div class="no-data">{{text}}</div>
      </el-card>
    </div>

  </div>
</template>
<script>
export default {
  props: ['params', 'router', 'height', 'text'],
  data() {
    return {
      loading: true,
      src: require('../../../assets/images/无子账户.png')
    }
  },
  methods: {
    goRouter() {
      this.$router.push('sub-account')
    },
    getKey(key) {
      let items = this.$t('common.three_list')
      return items[key] ? items[key] : key
    },
    classColor(status) {
      // "submitted": ["已提交", "已提交", "Submitted"],
      // "checking": ["校验中", "校驗中", "Checking"],
      // "verified": ["已校验", "已校驗", "Verified"],
      // "processing": ["在处理", "在處理", "Processing"],
      // "completed": ["完成", "完成", "Completed"],
      // "failure": ["失败", "失敗", "Failure"]
      return {
        'status-completed': status == 'completed',
        'status-failure': status == 'failure',
        'status-submitted': status == 'submitted',
        'status-checking': status == 'checking',
        'status-processing': status == 'processing',
        'status-verified': status == 'verified'
      }
    },
    classCardColor(status) {
      // "submitted": ["已提交", "已提交", "Submitted"],
      // "checking": ["校验中", "校驗中", "Checking"],
      // "verified": ["已校验", "已校驗", "Verified"],
      // "processing": ["在处理", "在處理", "Processing"],
      // "completed": ["完成", "完成", "Completed"],
      // "failure": ["失败", "失敗", "Failure"]
      return {
        'box-card-completed': status == 'completed',
        'box-card-failure': status == 'failure',
        'box-card-submitted': status == 'submitted',
        'box-card-checking': status == 'checking',
        'box-card-processing': status == 'processing',
        'box-card-verified': status == 'verified'
      }
    }
  },
  computed: {},
  filters: {
    GetDate(timestamp) {
      var date = new Date(timestamp)
      var Y = date.getFullYear() + '-'
      var M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return Y + M + D
    },
    GetTime(timestamp) {
      var date = new Date(timestamp)
      var h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      var s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return h + m + s
    }
  }
}
</script>

<style lang="scss">
.records-list-tree {
  .data-time{
    color: #7d7d7d;
  }
  .data-con{
    font-size: 12px;
  }
  .el-row:not(:first-child) {
    border-top: 1px solid #e2e2e2;
  }
  .el-card{
    border: none;
    border-left: 2px solid #ededed;
    border-right: 2px solid #ededed;
  }

  margin: 0;
  background: #fff;
  padding: 0 30px;

  .title {
    border-bottom: 4px solid #e2e2e2;
    margin: 0;
    padding: 20px 0;
    font-weight: 600;
    color: #182a54;
    font-size: 18px;
    font-family: Muli-Bold;

    span {
      display: inline-block;
      width: 50%;
    }

    small {
      display: inline-block;
      width: 50%;
      text-align: right;
      font-size: 12px;
      font-weight: bold;
      color: #fec000;
    }
  }

  .loading {
    height: 500px;
  }

  .no-data {
    font-family: PingFangTC-Regular;
    font-size: 12px;
    color: #7d7d7d;
    letter-spacing: -0.19px;
    margin-top: 16px;
  }
  .ai-jc {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .status-width {
    text-align: center;
    color: #fff;
    width: 100px;
  }

  .loading {
    height: 500px;
  }

  .status-width {
    text-align: center;
    color: #fff;
    width: 100px;
  }
  .text-right {
    padding-top: 4px;
    line-height: 16px;
  }
  .t-c {
    text-align: center;
  }
  .status-completed {
    background-color: #7BCC5B;
  }
  .status-failure {
    background-color: #E02A2A;
  }
  .status-submitted, .status-checking, .status-processing, .status-verified {
    background-color: #7D7D7D;
  }
  .box-card-completed {
    border-bottom: 4px solid #7BCC5B;
  }
  .box-card-failure {
    border-bottom: 4px solid #E02A2A;
  }
  .box-card-submitted, .box-card-checking, .box-card-processing, .box-card-verified{
    border-bottom: 4px solid #7D7D7D;
  }
  .box-card {
    margin: 20px 0;
  }
  .content-right {
    font-size: 12px;
    color: #24282d;
    font-weight: bold;
  }
  .content-left {
    font-size: 12px;
    color: #7d7d7d;
    padding-top: 4px;
    font-family: 'Muli-Regular';
  }
  .el-card__body {
    padding: 6px 20px;
  }

  .el-row {
    padding: 8px 0;

    .param-name,
    .param-value {
      // font-size: 14px;
    }

    .param-name {
      // color: #999;
    }
  }
}
@media (max-width: 768px) {
  .m15 {
    margin-left: -15px;
    margin-right: -15px;
  }
}
</style>
